<template>
  <q-card class="full-width">
    <template v-if="inventoryItem">
      <q-item-label header class="q-py-none">
        Inventory Item
      </q-item-label>

      <InventoryItem
        :item="inventoryItem"
        simple
      >
        <cancel-button
          label="Unlink Inventory Item"
          @click="$emit('remove')"
        />
      </InventoryItem>
    </template>

    <page-banner
      v-else
      dense
    >
      <q-item-label>
        Line items which don't have a linked inventory item will automatically be attached to the default <b>General Service</b> item
      </q-item-label>

      <template #action>
        <q-btn
          v-if="canCreateAsInventoryItem && can(permissions.canManageInventory)"
          color="white"
          text-color="black"
          no-caps
          icon="mdi-package-variant"
          label="Save as new Inventory Item"
          @click="addInventoryWithPayload"
        />
      </template>
    </page-banner>

    <AddInventoryDialog
      ref="addDialog"
      @created="$emit('create', $event)"
    />
  </q-card>
</template>

<script>
import InventoryItem from 'components/app/inventory/partials/InventoryItem'
import AddInventoryDialog from 'components/app/inventory/Add'
import { convertToReferenceNumber } from 'src/helpers/globals'

export default {
  components: {
    InventoryItem, AddInventoryDialog
  },
  props: {
    taxType: {
      type: String,
      required: true
    },
    inventoryItem: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    unitPrice: {
      type: Number,
      default: 0
    }
  },
  emits: ['remove', 'create'],
  computed: {
    prefillCol () {
      return this.$store.getters['company/getCompany'].inventory_prefill_column
    },
    canCreateAsInventoryItem () {
      const desc = this.description || ''

      if (this.prefillCol === 'DESCRIPTION' && desc.length > 0) {
        return true
      }

      return !(desc.length < 1 || desc.length > 50 || desc.includes('\n'))
    }
  },
  methods: {
    addInventoryWithPayload () {
      const payload = {
        type: 'SERVICE',
        selling_unit_price: this.unitPrice,
        selling_tax_type: this.taxType
      }

      if (this.prefillCol === 'DESCRIPTION') {
        payload.description = this.description
      }
      else {
        payload.code = convertToReferenceNumber(this.description, 30)
        payload.name = this.description
      }

      this.$refs.addDialog.open(payload)
    }
  }
}
</script>
